// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../min/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var min = convertToFP(fn, 1);
export default min;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/min/index.js
// module id = 959
// module chunks = 0